import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { URLParameters } from '@/app/common/urlParameters';
import { updateUrl } from '@/app/common/urlParametersUtils';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { useOffersContext } from '@/app/components/hotel-detail/OffersProvider';
import { getOptionKey } from '@/app/components/hotel-detail/rooms/roomCommon';
import { useUrlSearchParams } from '@/app/components/hotel-detail/UrlSearchParamsProvider';
import { useTranslation } from '@/app/components/translations/Translation';
import { Button, Text } from '@lmn/design-system';
import styled from 'styled-components';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';

export function MealPlanFilterMessage(props: React.HTMLAttributes<HTMLElement>) {
  const { accommodationOnly, freeCancellationFilter, mealPlanFilterValues } = useUrlSearchParams();
  const { offersData, setApplyMealPlanFilter } = useOffersContext();
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const priceDiff =
    (offersData?.cheapestMealPlan?.finalPrice ?? 0) - (offersData?.cheapestFilteredMealPlan?.finalPrice ?? 0);

  const resetFilterOnClick = () => {
    updateUrl({
      queryParamsToRemove: [URLParameters.MEAL, URLParameters.MEALPLAN, URLParameters.FREE_CANCELLATION],
    });
    setApplyMealPlanFilter(false);
  };
  return (
    <MealPlanFilterMessageContainer {...props}>
      <div
        css={`
          display: flex;
          flex-direction: column;
          gap: 2px;
          flex-grow: 1;
        `}
      >
        <Text variant="BodySmall">{t('vacation.select.room_pannel.filter_applied')}</Text>
        <Text variant="Title5">
          {(mealPlanFilterValues as (CancellationType | BoardClassType)[])
            .concat(freeCancellationFilter ? ['REFUNDABLE'] : [])
            .map((value) => t(getOptionKey(value, accommodationOnly)))
            .filter((value) => value)
            .join(', ')}
        </Text>
      </div>
      <Button
        variant="primary"
        appearance="outlined"
        onClick={resetFilterOnClick}
        css={`
          border: 0;
        `}
      >
        <Text variant="Title5">{`${t('vacation.common.filters.results.showall')}${priceDiff > 0 ? `(-${formatPrice({ price: priceDiff, localization })})` : ''}`}</Text>
      </Button>
    </MealPlanFilterMessageContainer>
  );
}

const MealPlanFilterMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${(p) => p.theme.commons.colors.warning100};

  @media ${customCss.breakpoints.sm} {
    flex-direction: row;
  }
`;
